import React, { useState } from "react";
import classes from "./location.module.css";
import { Typography, Button, Grid, Box, ToggleButton, ToggleButtonGroup, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getLanguagedataFunction } from "../../../utilities/language";
import { SaveViewAll } from "../../../Redux/actions/location-action";
import { BsFillGrid3X3GapFill } from "react-icons/bs";
import { FaList } from "react-icons/fa";
import MyTableBody from "../../../components/LocationListView";
import LocationCard from "./locationCard";

const LocattionBoxContainer = ({
  locationList,
  viewAll,
  fromDate,
  toDate,
  setUpdateState,
  loading,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState("grid");
  const ln = useSelector((state) => state.allUsers.language_json);
  // const { locationList, locationFilteredStatus, locationFilterTime, locationFilterMembers, viewAll } =
  //   useSelector((state) => state.location);

  React.useEffect(() => {
    if (!ln) {
      getLanguagedataFunction(dispatch);
    }
  }, [dispatch, ln]);

  const handleViewAll = (e) => {
    e.stopPropagation();
    navigate("/location");
    dispatch(SaveViewAll(true));
  };

  const handleCardClick = (e, item) => {
    // A future day of a repeating task isn't created yet — nothing to open.
    if (item.is_projected) return;
    const name = item.slug.toLowerCase();
    navigate(`/location/${name}`);
    e.preventDefault();
  };

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  return (
    <div>
      {ln ? (
        <div>
          <div className={classes.viewstyleContainer}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Typography className={classes.viewstyleText}>
                {ln.recent_locations} ({locationList?.length})
              </Typography>
              <ToggleButtonGroup
                value={activeButton}
                exclusive
                onChange={(_, val) => val && handleButtonClick(val)}
                size="small"
                sx={{
                  ml: 2,
                  "& .MuiToggleButton-root": {
                    color: "#888888 !important",
                    bgcolor: "white",
                    "&:hover": { bgcolor: "#e8f0f8" },
                    "&.Mui-selected": {
                      color: "white !important",
                      bgcolor: "#227dc3",
                      "&:hover": { bgcolor: "#1a6ab0" },
                    },
                  },
                }}
              >
                <ToggleButton value="grid">
                  <BsFillGrid3X3GapFill color={activeButton === "grid" ? "white" : "#888888"} />
                </ToggleButton>
                <ToggleButton value="list">
                  <FaList color={activeButton === "list" ? "white" : "#888888"} />
                </ToggleButton>
              </ToggleButtonGroup>
            </div>
            <div>
              {window.location.pathname === "/home" && (
                <Button
                  variant="text"
                  style={{ textTransform: "none" }}
                  onClick={(e) => handleViewAll(e)}
                >
                  {viewAll ? ln.viewless : ln.viewall}
                </Button>
              )}
            </div>
          </div>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
              <CircularProgress />
            </Box>
          ) : activeButton === "grid" ? (
            <Box sx={{ mt: 3 }}>
              <Grid container spacing={3}>
                {locationList?.length > 0 ? (
                  locationList.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={item._id || index}>
                      <LocationCard
                        item={item}
                        index={index}
                        handleCardClick={handleCardClick}
                        ln={ln}
                        fromDate={fromDate}
                        toDate={toDate}
                        setUpdateState={setUpdateState}
                      />
                    </Grid>
                  ))
                ) : (
                  <Grid item xs={12}>
                    <Typography align="center" color="text.secondary">
                      No data found
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Box>
          ) : (
            <div>
              <MyTableBody
                list={locationList}
                handleCardClick={handleCardClick}
              />
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default LocattionBoxContainer;
